export default __webpack_public_path__ + "static/media/Doubly_List_Deletion_1.7df52b24.gif";